import axios from 'axios';

import store from '../store';
import { getSessionId } from '../reducers/app/sessionId';

import config from '../config';
import { isArray } from './array';

const request = axios.create({
  baseURL: config.simplifyApiUrl,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

const handleError = (error) => {
  const { response, request, message } = error;

  if (!response) {
    throw new Error(error);
  }

  const { status, statusText, config } = response;
  const { url } = config;

  if (status) {
    switch (status) {
      case 404:
      default:
        throw new Error('Resource', url, status, statusText);
    }
  } else if (request) {
    throw new Error('Resource', url, request);
  } else {
    throw new Error('Resource', url, message);
  }
};

const getHeaders = (params) => ({
  headers: {
    'X-SessionId': getSessionId(store.getState()),
    'X-SiteId': config.siteId,
    ...params.headers,
  },
});

export const resource = (params) => request({ ...params, ...getHeaders(params) }).catch(handleError);

const handleNormalize = (rootKey, normalizer, rootData = {}) => (response) => {
  const data = rootKey ? response.data[rootKey] : response.data;
  let normalizedData = null;

  if (!data) {
    console.error('handleNormalize', `data is \`${data}\`. Check normalizer \`${normalizer.name}\``);
  }

  if (isArray(data)) {
    normalizedData = data.map(normalizer);
  } else {
    normalizedData = normalizer(data);
  }

  return {
    ...rootData,
    data: normalizedData,
  };
};

const createResourceHandler = endpoint => (params) => {
  const {
    rootKey,
    rootData,
    normalizer,
    ...config
  } = endpoint(params);

  if (normalizer) {
    return resource(config).then(handleNormalize(rootKey, normalizer, rootData));
  }

  return resource(config).then(resp => ({ ...rootData, data: resp.data }));
};

export const createResourceRequests = (endpoints) => {
  const endpointNames = Object.keys(endpoints);
  const actions = {};

  endpointNames.forEach((name) => {
    actions[name] = createResourceHandler(endpoints[name]);
  });

  return actions;
};

const camelize = str => (str === str.toUpperCase()) ?
  str.toLowerCase()
  :
  `${str[0].toLowerCase()}${str.slice(1, str.length).replace('ID', 'Id').replace('URL', 'Url')}`;

const pascalize = str => (`${str[0].toUpperCase()}${str.slice(1, str.length)}`);

const createResourceNormalizer = normalizer => (props) => {
  const resource = {};

  Object.keys(props).forEach((propName) => {
    resource[normalizer(propName)] = props[propName];
  });

  return resource;
};

export const camelizeResource = createResourceNormalizer(camelize);
export const pascalizeResource = createResourceNormalizer(pascalize);


// WEBPACK FOOTER //
// ./src/helpers/resource.js